import { InjectionToken } from '@angular/core';
import { ResourceService } from '@softline/core';

//TODO: Besseren namen suchen oder als default im core festlegen ?
export const SOFTLINE_STORE_DATA_SERVICE = new InjectionToken<
  ResourceService<any>
>('SOFTLINE_STORE_DATA_SERVICE');
